import type { IconSvgObject } from './types';

const ChevronsRightLeftIcon: IconSvgObject = [
  ["path", { d: "M20 7L15 12L20 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 7L9 12L4 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsRightLeftIcon;
